import React from 'react';

function PlayerYoutube({ linkPlay }) {
	const idYtb = linkPlay.split('=')[1];
	return (
		<div>
			<iframe
				width='100%'
				src={`https://www.youtube.com/embed/${idYtb}`}
				title='YouTube video player'
				frameBorder='0'
				allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
				allowFullScreen
				className='rounded-md lg:h-[460px] h-[300px]'
			></iframe>
		</div>
	);
}

export default PlayerYoutube;
